import { cloneElement, forwardRef } from "react"
// components
import { Loader } from "@components/Loader"
// helper
import { getButtonStyling, getIconStyling } from "./helper"

export const Button = forwardRef(function Button(props, ref) {
  const {
    variant = "primary",
    size = "md",
    className = "",
    type = "button",
    loading = false,
    disabled = false,
    prependIcon = null,
    appendIcon = null,
    text,
    iconSize = '',
    ...rest
  } = props

  const buttonStyle = getButtonStyling(variant, size, disabled || loading)
  const buttonIconStyle = getIconStyling(size)

  return (
    <button
      ref={ref}
      type={type}
      className={`${buttonStyle} ${className} font-bold flex items-center justify-center gap-2`}
      disabled={disabled || loading}
      {...rest}
    >
      {prependIcon && (
        <div className={` ${iconSize ?? ""} ${buttonIconStyle}`}>
          {cloneElement(prependIcon, { strokeWidth: 2 })}
        </div>
      )}

      {text}
      {loading && <Loader size="sm" />}

      {appendIcon && (
        <div className={buttonIconStyle}>
          {cloneElement(appendIcon, { strokeWidth: 2 })}
        </div>
      )}
    </button>
  )
})
